import { Configuration, ConfigurationObject } from "./shared/interfaces";
const { REACT_APP_ENV = "dev" } = process.env;

const dev: Configuration = {
  env: REACT_APP_ENV,
  version: process.env.REACT_APP_VERSION || "1.0.0",
  baseApiUrl: "http://localhost:4000/api/v1/",
};

const qa: Configuration = {
  ...dev,
  baseApiUrl: "https://api.qa.live.distasense.com/api/v1/",
};

const stage: Configuration = {
  ...dev,
  baseApiUrl: "https://api.uat.live.distasense.com/api/v1/",
};

const production: Configuration = {
  ...dev,
  baseApiUrl: "https://api.live.distasense.com/api/v1/",
};

const config: ConfigurationObject = {
  dev,
  qa,
  production,
  stage,
};

const configElement: Configuration = config[REACT_APP_ENV];
export default configElement;
